var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      style: _vm.modalStyle,
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        forceRender: true,
        fullscreen: "",
        switchFullscreen: "",
        wrapClassName: "ant-modal-cust-warp",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
            _vm._v("取消(ESC)"),
          ]),
          _vm.isShowPrintBtn
            ? [
                _vm.billPrintFlag
                  ? _c("a-button", { on: { click: _vm.handlePrintPro } }, [
                      _vm._v("三联打印-新版"),
                    ])
                  : _vm._e(),
                _vm.billPrintFlag
                  ? _c("a-button", { on: { click: _vm.handlePrint } }, [
                      _vm._v("三联打印"),
                    ])
                  : _vm._e(),
                _vm.billType === "零售出库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#retailOutPrint",
                            expression: "'#retailOutPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "零售退货入库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#retailBackPrint",
                            expression: "'#retailBackPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "请购单"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#purchaseApplyPrint",
                            expression: "'#purchaseApplyPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "采购订单"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#purchaseOrderPrint",
                            expression: "'#purchaseOrderPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "采购入库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#purchaseInPrint",
                            expression: "'#purchaseInPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "采购退货出库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#purchaseBackPrint",
                            expression: "'#purchaseBackPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "销售订单"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#saleOrderPrint",
                            expression: "'#saleOrderPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "销售出库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#saleOutPrint",
                            expression: "'#saleOutPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "销售退货入库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#saleBackPrint",
                            expression: "'#saleBackPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "其它入库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#otherInPrint",
                            expression: "'#otherInPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "其它出库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#otherOutPrint",
                            expression: "'#otherOutPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "调拨出库"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#allocationOutPrint",
                            expression: "'#allocationOutPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "组装单"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#assemblePrint",
                            expression: "'#assemblePrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "拆卸单"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#disassemblePrint",
                            expression: "'#disassemblePrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "盘点复盘"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#stockCheckReplayPrint",
                            expression: "'#stockCheckReplayPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
                _vm.billType === "盘点录入"
                  ? _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#stockCheckEnterPrint",
                            expression: "'#stockCheckEnterPrint'",
                          },
                        ],
                      },
                      [_vm._v("普通打印")]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.billType === "零售出库" || _vm.billType === "零售退货入库"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.retailExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.billType === "请购单"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.applyExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.billType === "采购订单" || _vm.billType === "销售订单"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.orderExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.billType === "采购入库" ||
          _vm.billType === "采购退货出库" ||
          _vm.billType === "销售出库" ||
          _vm.billType === "销售退货入库"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.purchaseSaleExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.billType === "其它入库" || _vm.billType === "其它出库"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.otherExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.billType === "调拨出库"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.allocationOutExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.billType === "组装单" || _vm.billType === "拆卸单"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.assembleExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.billType === "盘点复盘"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.stockCheckReplayExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.billType === "盘点录入"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.stockCheckEnterExportExcel()
                    },
                  },
                },
                [_vm._v("导出")]
              )
            : _vm._e(),
          _vm.checkFlag && _vm.isCanBackCheck && _vm.model.status === "1"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleBackCheck()
                    },
                  },
                },
                [_vm._v("反审核")]
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "a-form",
        { attrs: { form: _vm.form } },
        [
          _vm.billType === "零售出库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "retailOutPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "会员卡号",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "收款类型",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.payType) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c("a-col", { attrs: { lg: 18, md: 12, sm: 24 } }, [
                          _c(
                            "div",
                            { style: _vm.tableWidthRetail },
                            [
                              _c("a-table", {
                                ref: "table",
                                attrs: {
                                  size: "middle",
                                  bordered: "",
                                  rowKey: "id",
                                  pagination: false,
                                  loading: _vm.loading,
                                  columns: _vm.columns,
                                  dataSource: _vm.dataSource,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "customBarCode",
                                      fn: function (text, record) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              style: record.imgName
                                                ? "float:left;line-height:30px"
                                                : "float:left;",
                                            },
                                            [_vm._v(_vm._s(record.barCode))]
                                          ),
                                          _c(
                                            "a-popover",
                                            {
                                              attrs: {
                                                placement: "right",
                                                trigger: "click",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "content" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgLarge
                                                      ),
                                                      width: "500px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              record.imgName
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "item-info",
                                                    },
                                                    [
                                                      record.imgName
                                                        ? _c("img", {
                                                            staticClass:
                                                              "item-img",
                                                            attrs: {
                                                              src: _vm.getImgUrl(
                                                                record.imgName,
                                                                record.imgSmall
                                                              ),
                                                              title: "查看大图",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4169317351
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 24 },
                              },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { lg: 24, md: 6, sm: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "单据金额",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.model.changeAmount) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { lg: 24, md: 6, sm: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "收款金额",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.model.getAmount) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { lg: 24, md: 6, sm: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "找零",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.model.backAmount) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { lg: 24, md: 6, sm: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "收款账户",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.model.accountName) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.model.hasBackFlag
                                  ? _c(
                                      "a-col",
                                      { attrs: { lg: 24, md: 6, sm: 6 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              labelCol: _vm.labelCol,
                                              wrapperCol: _vm.wrapperCol,
                                              label: "退货单号",
                                            },
                                          },
                                          [
                                            _vm._l(
                                              _vm.linkNumberList,
                                              function (item, index) {
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.myHandleDetail(
                                                            item.number
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.number)
                                                      ),
                                                    ]
                                                  ),
                                                  _c("br"),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "零售退货入库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "retailBackPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "会员卡号",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "关联单据",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.myHandleDetail(
                                          _vm.model.linkNumber
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.model.linkNumber))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c("a-col", { attrs: { lg: 18, md: 12, sm: 24 } }, [
                          _c(
                            "div",
                            { style: _vm.tableWidthRetail },
                            [
                              _c("a-table", {
                                ref: "table",
                                attrs: {
                                  size: "middle",
                                  bordered: "",
                                  rowKey: "id",
                                  pagination: false,
                                  loading: _vm.loading,
                                  columns: _vm.columns,
                                  dataSource: _vm.dataSource,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "customBarCode",
                                    fn: function (text, record) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            style: record.imgName
                                              ? "float:left;line-height:30px"
                                              : "float:left;",
                                          },
                                          [_vm._v(_vm._s(record.barCode))]
                                        ),
                                        _c(
                                          "a-popover",
                                          {
                                            attrs: {
                                              placement: "right",
                                              trigger: "click",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "content" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.getImgUrl(
                                                      record.imgName,
                                                      record.imgLarge
                                                    ),
                                                    width: "500px",
                                                  },
                                                }),
                                              ]
                                            ),
                                            record.imgName
                                              ? _c(
                                                  "div",
                                                  { staticClass: "item-info" },
                                                  [
                                                    record.imgName
                                                      ? _c("img", {
                                                          staticClass:
                                                            "item-img",
                                                          attrs: {
                                                            src: _vm.getImgUrl(
                                                              record.imgName,
                                                              record.imgSmall
                                                            ),
                                                            title: "查看大图",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 24 },
                              },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { lg: 24, md: 6, sm: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "单据金额",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.model.changeAmount) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { lg: 24, md: 6, sm: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "付款金额",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.model.getAmount) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { lg: 24, md: 6, sm: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "找零",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.model.backAmount) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { lg: 24, md: 6, sm: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "付款账户",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.model.accountName) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "请购单"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "purchaseApplyPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "采购订单"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "purchaseOrderPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "供应商",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.model.linkApply
                          ? _c(
                              "a-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: {
                                        xs: { span: 24 },
                                        sm: { span: 6 },
                                      },
                                      wrapperCol: _vm.wrapperCol,
                                      label: "关联请购单",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.myHandleDetail(
                                              _vm.model.linkApply
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.model.linkApply))]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.model.linkNumber
                          ? _c(
                              "a-col",
                              { attrs: { span: 6 } },
                              [
                                _vm.purchaseBySaleFlag
                                  ? _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "关联订单",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.model.linkNumber) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠率",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discount) +
                                    "%\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "付款优惠",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: {
                                    xs: { span: 24 },
                                    sm: { span: 6 },
                                  },
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠后金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountLastMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "结算账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "支付订金",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "采购入库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "purchaseInPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "供应商",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "关联订单",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.myHandleDetail(
                                          _vm.model.linkNumber
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.model.linkNumber))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠率",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discount) +
                                    "%\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "付款优惠",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: {
                                    xs: { span: 24 },
                                    sm: { span: 6 },
                                  },
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠后金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountLastMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "其它费用",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.otherMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "结算账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.model.deposit
                          ? _c(
                              "a-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "扣除订金",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.model.deposit) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "本次付款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "本次欠款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.debt) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.model.hasBackFlag
                          ? _c(
                              "a-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "退货单号",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm.linkNumberList,
                                      function (item, index) {
                                        return [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.myHandleDetail(
                                                    item.number
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item.number))]
                                          ),
                                          _c("br"),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _vm.financialBillNoList.length
                          ? _c(
                              "a-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "付款单号",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm.financialBillNoList,
                                      function (item, index) {
                                        return [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.myHandleFinancialDetail(
                                                    item.billNo
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item.billNo))]
                                          ),
                                          _c("br"),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "采购退货出库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "purchaseBackPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "供应商",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "关联单据",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.myHandleDetail(
                                          _vm.model.linkNumber
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.model.linkNumber))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠率",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discount) +
                                    "%\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "退款优惠",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: {
                                    xs: { span: 24 },
                                    sm: { span: 6 },
                                  },
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠后金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountLastMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "其它费用",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.otherMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "结算账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "本次退款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "本次欠款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.debt) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "销售订单"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "saleOrderPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "客户",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "销售人员",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.salesManStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠率",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discount) +
                                    "%\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "收款优惠",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: {
                                    xs: { span: 24 },
                                    sm: { span: 6 },
                                  },
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠后金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountLastMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "结算账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "收取订金",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "销售出库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "saleOutPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "客户",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "关联订单",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.myHandleDetail(
                                          _vm.model.linkNumber
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.model.linkNumber))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠率",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discount) +
                                    "%\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "收款优惠",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: {
                                    xs: { span: 24 },
                                    sm: { span: 6 },
                                  },
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠后金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountLastMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "其它费用",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.otherMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "结算账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.model.deposit
                          ? _c(
                              "a-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "扣除订金",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.model.deposit) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "本次收款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "本次欠款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.debt) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.model.hasBackFlag
                          ? _c(
                              "a-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "退货单号",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm.linkNumberList,
                                      function (item, index) {
                                        return [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.myHandleDetail(
                                                    item.number
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item.number))]
                                          ),
                                          _c("br"),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "销售人员",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.salesManStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.financialBillNoList.length
                          ? _c(
                              "a-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "收款单号",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm.financialBillNoList,
                                      function (item, index) {
                                        return [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.myHandleFinancialDetail(
                                                    item.billNo
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item.billNo))]
                                          ),
                                          _c("br"),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "销售退货入库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "saleBackPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "客户",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "关联单据",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.myHandleDetail(
                                          _vm.model.linkNumber
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.model.linkNumber))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠率",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discount) +
                                    "%\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "退款优惠",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: {
                                    xs: { span: 24 },
                                    sm: { span: 6 },
                                  },
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠后金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountLastMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "其它费用",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.otherMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "结算账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "本次退款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "本次欠款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.debt) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "销售人员",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.salesManStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "其它入库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "otherInPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "供应商",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.model.billType
                              ? _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "关联单据",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.model.linkNumber) +
                                        " " +
                                        _vm._s(_vm.model.billType) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            !_vm.model.billType
                              ? _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "关联单据",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.myHandleDetail(
                                              _vm.model.linkNumber
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.model.linkNumber))]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "其它出库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "otherOutPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "客户",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.model.billType
                              ? _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "关联单据",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.model.linkNumber) +
                                        " " +
                                        _vm._s(_vm.model.billType) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            !_vm.model.billType
                              ? _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "关联单据",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.myHandleDetail(
                                              _vm.model.linkNumber
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.model.linkNumber))]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "调拨出库"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "allocationOutPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "组装单"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "assemblePrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "拆卸单"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "disassemblePrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "盘点复盘"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "stockCheckReplayPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "关联单据",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.linkNumber) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.billType === "盘点录入"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "stockCheckEnterPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.operTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.number) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "关联单据",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.linkNumber) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { style: _vm.tableWidth },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            pagination: false,
                            loading: _vm.loading,
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "customBarCode",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: record.imgName
                                        ? "float:left;line-height:30px"
                                        : "float:left;",
                                    },
                                    [_vm._v(_vm._s(record.barCode))]
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgLarge
                                            ),
                                            width: "500px",
                                          },
                                        }),
                                      ]),
                                      record.imgName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-info" },
                                            [
                                              record.imgName
                                                ? _c("img", {
                                                    staticClass: "item-img",
                                                    attrs: {
                                                      src: _vm.getImgUrl(
                                                        record.imgName,
                                                        record.imgSmall
                                                      ),
                                                      title: "查看大图",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.fileList && _vm.fileList.length > 0
            ? [
                _c(
                  "a-row",
                  { staticClass: "form-row", attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "a-form-item",
                          {
                            attrs: {
                              labelCol: { xs: { span: 24 }, sm: { span: 3 } },
                              wrapperCol: {
                                xs: { span: 24 },
                                sm: { span: 21 },
                              },
                              label: "附件",
                            },
                          },
                          [
                            _c("j-upload", {
                              attrs: {
                                bizPath: "bill",
                                disabled: true,
                                buttonVisible: false,
                              },
                              model: {
                                value: _vm.fileList,
                                callback: function ($$v) {
                                  _vm.fileList = $$v
                                },
                                expression: "fileList",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-col", { attrs: { span: 14 } }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("bill-print-iframe", { ref: "modalDetail" }),
      _c("bill-print-pro-iframe", { ref: "modalProDetail" }),
      _c("bill-print-hiprint", { ref: "modalHiprintDetail" }),
      _c("financial-detail", { ref: "financialDetailModal" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }